import { render, staticRenderFns } from "./drivingPermits.vue?vue&type=template&id=41612684&scoped=true"
import script from "./drivingPermits.vue?vue&type=script&lang=js"
export * from "./drivingPermits.vue?vue&type=script&lang=js"
import style0 from "./drivingPermits.vue?vue&type=style&index=0&id=41612684&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41612684",
  null
  
)

export default component.exports